const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbcBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.333 501.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F16D6E"
    },
    d: "M365.867,186.667c0,25.6-21.333,46.933-46.933,46.933H182.4c-25.6,0-46.933-21.333-46.933-46.933 V46.933C135.467,21.333,156.8,0,182.4,0h136.533c25.6,0,46.933,21.333,46.933,46.933L365.867,186.667L365.867,186.667z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.467,186.667c-1.067,0-3.2,0-4.267-1.067c-5.333-2.133-7.467-8.533-5.333-13.867l51.2-117.333 c2.133-4.267,5.333-6.4,9.6-6.4l0,0c4.267,0,8.533,2.133,9.6,6.4l51.2,117.333c2.133,5.333,0,11.733-5.333,13.867 c-5.333,2.133-11.733,0-13.867-5.333l-41.6-94.933l-41.6,94.933C206.933,184.533,203.733,186.667,199.467,186.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M285.867,151.467h-69.333c-6.4,0-10.667-5.333-10.667-10.667c0-6.4,5.333-10.667,10.667-10.667 h69.333c6.4,0,10.667,5.333,10.667,10.667C296.533,147.2,291.2,151.467,285.867,151.467z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60C3AB"
    },
    d: "M230.4,454.4c0,25.6-21.333,46.933-46.933,46.933H46.933C21.333,501.333,0,480,0,454.4V314.667 c0-25.6,21.333-46.933,46.933-46.933h136.533c25.6,0,46.933,21.333,46.933,46.933V454.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC656"
    },
    d: "M501.333,454.4c0,25.6-21.333,46.933-46.933,46.933H317.867c-25.6,0-46.933-21.333-46.933-46.933 V314.667c0-25.6,21.333-46.933,46.933-46.933H454.4c25.6,0,46.933,21.333,46.933,46.933V454.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M391.467,460.8c-35.2,0-64-34.133-64-76.8s28.8-76.8,64-76.8c21.333,0,40.533,11.733,52.267,33.067 c3.2,5.333,1.067,11.733-4.267,14.933c-5.333,3.2-11.733,1.067-14.933-4.267c-8.533-13.867-20.267-22.4-34.133-22.4 c-23.467,0-42.667,24.533-42.667,54.4s19.2,54.4,42.667,54.4c12.8,0,24.533-7.467,33.067-20.267c3.2-5.333,9.6-6.4,14.933-3.2 c5.333,3.2,6.4,9.6,3.2,14.933C429.867,450.133,411.733,460.8,391.467,460.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M117.333,458.667H70.4c-6.4,0-10.667-5.333-10.667-10.667v-68.267c0-6.4,5.333-10.667,10.667-10.667 h46.933c29.867,0,53.333,20.267,53.333,44.8S147.2,458.667,117.333,458.667z M81.067,437.333h36.267c17.067,0,32-10.667,32-23.467 s-14.933-23.467-32-23.467H81.067V437.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M110.933,390.4H70.4c-6.4,0-10.667-5.333-10.667-10.667v-58.667c0-6.4,5.333-10.667,10.667-10.667 H112c26.667,0,48,18.133,48,40.533S137.6,390.4,110.933,390.4z M81.067,369.067h29.867c13.867,0,26.667-8.533,26.667-19.2 s-11.733-19.2-26.667-19.2H81.067V369.067z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcBlock);
export default __webpack_public_path__ + "static/media/abcBlock.916e4954d77ec02e6066e09a9c7a5bc0.svg";
export { ForwardRef as ReactComponent };